import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { CAESAR_OPCIOK } from '../caesar.opciok';

// Egy ügy teljes nézete: Áttekintés (törzs), Szereplők (személy+szerepkör), Iratok (MinIO).
@Component({
  selector: 'app-caesar-ugy',
  templateUrl: './ugy.component.html',
  styleUrls: ['./ugy.component.scss'],
})
export class UgyComponent implements OnInit {
  @ViewChild('szereploModal') szereploModal: IonModal;
  @ViewChild('iratkeszModal') iratkeszModal: IonModal;
  opciok = CAESAR_OPCIOK;
  intezmeny = '';
  ugyId = '';
  segment = 'attekintes';

  ugy: any = null;
  szereplok: any[] = [];
  osszesites: any = {};
  ugytipusok: any[] = [];
  // Választható ügytípusok lapítva: alkategória „Fő › Al (BL)", gyerek nélküli fő önmagában.
  ugytipusValaszthato() {
    const lista = this.ugytipusok || [];
    const out: any[] = [];
    for (const fo of lista.filter((t: any) => !t.szulo_id)) {
      const alk = lista.filter((t: any) => t.szulo_id === fo.id);
      if (alk.length) {
        for (const a of alk) out.push({ id: a.id, label: `${fo.nev} › ${a.nev} (${(fo.elotag || '') + (a.elotag || '')})` });
      } else {
        out.push({ id: fo.id, label: `${fo.nev}${fo.elotag ? ' (' + fo.elotag + ')' : ''}` });
      }
    }
    return out;
  }
  szemelyek: any[] = [];
  iratok: any[] = [];
  sablonok: any[] = [];
  varazslok: any[] = [];
  hivatkozasok: any[] = [];
  hatosagok: any[] = [];
  ujHiv: any = { hatosag_nev: '', szam: '', megjegyzes: '' };

  // 4-5. fázis adatok
  hatarnapok: any[] = [];
  tennivalok: any[] = [];
  oradijak: any[] = [];
  koltsegek: any[] = [];
  letetek: any[] = [];
  pmtek: any[] = [];
  levelek: any[] = [];
  ujHatarnap: any = {};
  ujTennivalo: any = {};
  ujOradij: any = {};
  ujKoltseg: any = {};
  ujLetet: any = {};
  ujPmt: any = {};
  ujLevel: any = {};

  ujSzereplo: any = { szemely_id: '', szerep: 'Ügyfél', szerepEgyeb: '', sajat_ugyfel: true };
  szemelyKereso = '';              // a szereplő-modal kereshetős személyválasztója
  szemelyValasztott: any = null;
  feltoltIrany = 'beerkezo';
  feltoltTipus = 'egyeb';

  // iratkészítés sablonból / varázslóval
  iratkesz: any = { mod: 'sablon', id: '', pdf: true, alair: false, ertekek: {}, mezok: [] };
  keszites = false;

  // Hibrid (helyi mappás) ügy: a forrásmappa fa-struktúrája (read-only).
  hibridGyoker = '';
  hibridFa: any[] = [];
  hibridHiba = '';
  eszignoElerheto = false;   // e-Szignó aláírás be van-e állítva (config.env ESZIGNO_CMD)

  constructor(
    private http: HttpClient, private data: DataService, private route: ActivatedRoute,
    private router: Router, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    this.ugyId = this.route.snapshot.paramMap.get('id') || '';
    this.ugytipusok = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugytipusok/' + this.intezmeny));
    this.szemelyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/szemelyek/' + this.intezmeny));
    this.sablonok = await firstValueFrom(this.http.get<any[]>('/api/caesar/sablonok/' + this.intezmeny));
    this.varazslok = await firstValueFrom(this.http.get<any[]>('/api/caesar/varazslok/' + this.intezmeny));
    this.hatosagok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatosagok/' + this.intezmeny));
    try { this.eszignoElerheto = !!(await firstValueFrom(this.http.get<any>('/api/caesar/eszigno-statusz')))?.elerheto; } catch { this.eszignoElerheto = false; }
    await this.betolt();
  }

  async betolt() {
    try {
      const r: any = await firstValueFrom(this.http.get('/api/caesar/ugy/' + this.ugyId));
      this.ugy = r.ugy;
      this.szereplok = (r.szereplok || []).map((s: any) => ({
        ...s,
        // az extra (JSON map) → szerkeszthető kulcs/érték sorok a loop-változókhoz
        extraSorok: Object.entries(s.extra || {}).map(([kulcs, ertek]) => ({ kulcs, ertek })),
      }));
      this.osszesites = r.osszesites || {};
      if (this.ugy?.hibrid) await this.betoltHibridFa();
    } catch { this.hiba('Nem sikerült betölteni az ügyet.'); }
  }

  /* ---- Hibrid mappa (read-only) ---- */
  async betoltHibridFa() {
    this.hibridHiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get('/api/caesar/hibrid/fajlok/' + this.ugyId));
      this.hibridGyoker = r.gyoker || '';
      this.hibridFa = r.fa || [];
      this.hibridHiba = r.hiba || '';
    } catch { this.hibridHiba = 'Nem sikerült beolvasni a mappát.'; }
  }
  // Egy fájl/mappa megnyitása a lemezen (a rendszer alap-alkalmazásával / fájlkezelőjével).
  async megnyitLemezen(rel: string) {
    try { await firstValueFrom(this.http.post('/api/caesar/hibrid/megnyit', { ugy_id: this.ugyId, gyoker: 'ugy', rel })); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült megnyitni a lemezen.'); }
  }

  async valtas(ev: any) {
    this.segment = ev.detail.value;
    const G = (u: string) => firstValueFrom(this.http.get<any[]>(u + this.ugyId));
    if (this.segment === 'iratok') this.iratok = await G('/api/caesar/iratok/');
    if (this.segment === 'hivatkozasok') this.hivatkozasok = await G('/api/caesar/hivatkozasok/');
    if (this.segment === 'hataridok') { this.hatarnapok = await G('/api/caesar/hatarnapok/'); this.tennivalok = await G('/api/caesar/tennivalok/'); this.ujUres(); }
    if (this.segment === 'penzugy') { this.oradijak = await G('/api/caesar/oradijak/'); this.koltsegek = await G('/api/caesar/koltsegek/'); this.letetek = await G('/api/caesar/letetek/'); this.ujUres(); }
    if (this.segment === 'pmt') { this.pmtek = await G('/api/caesar/pmt/ugy/'); this.ujUres(); }
    if (this.segment === 'postakonyv') { this.levelek = await G('/api/caesar/levelek/'); this.ujUres(); }
  }

  private ma() { return new Date().toISOString().slice(0, 10); }
  private ujUres() {
    this.ujHatarnap = { intezmeny: this.intezmeny, datum: this.ma(), megnevezes: '', hely: '' };
    this.ujTennivalo = { intezmeny: this.intezmeny, datum: this.ma(), szoveg: '', felelos: '', tipus: 'tennivalo' };
    this.ujOradij = { intezmeny: this.intezmeny, datum: this.ma(), leiras: '', ido_perc: 60, oradij: this.ugy?.oradij || null };
    this.ujKoltseg = { intezmeny: this.intezmeny, datum: this.ma(), kategoria: 'eljarasi', megnevezes: '', osszeg: 0, tovabbutalas: false };
    this.ujLetet = { intezmeny: this.intezmeny, atvetel_datum: this.ma(), jogcim: '', osszeg: 0, statusz: 'nyitott' };
    this.ujPmt = { intezmeny: this.intezmeny, ugy_id: this.ugyId, besorolas: '', kockazat: 'alacsony', atvilagitas: false, datum: this.ma() };
    this.ujLevel = { intezmeny: this.intezmeny, irany: 'kimeno', datum: this.ma(), partner: '', ragszam: '', leiras: '' };
  }

  // generikus add/törlés a per-ügy gyermekekhez
  private async post(url: string, body: any) { await firstValueFrom(this.http.post(url, body)); }
  private async del(url: string) { await firstValueFrom(this.http.delete(url)); }

  async hatarnapAdd() { if (!this.ujHatarnap.megnevezes?.trim()) return this.hiba('Megnevezés kötelező.'); await this.post('/api/caesar/hatarnap/' + this.ugyId, this.ujHatarnap); this.hatarnapok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatarnapok/' + this.ugyId)); this.ujUres(); await this.betolt(); }
  async hatarnapTorol(h: any) { await this.del('/api/caesar/hatarnap/' + h.id); this.hatarnapok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hatarnapok/' + this.ugyId)); await this.betolt(); }

  async tennivaloAdd() { if (!this.ujTennivalo.szoveg?.trim()) return this.hiba('Szöveg kötelező.'); await this.post('/api/caesar/tennivalo/' + this.ugyId, this.ujTennivalo); this.tennivalok = await firstValueFrom(this.http.get<any[]>('/api/caesar/tennivalok/' + this.ugyId)); this.ujUres(); await this.betolt(); }
  async tennivaloKesz(t: any) { await firstValueFrom(this.http.put('/api/caesar/tennivalo/' + t.id, { ...t, kesz: t.kesz ? 1 : 0 })); await this.betolt(); }
  async tennivaloTorol(t: any) { await this.del('/api/caesar/tennivalo/' + t.id); this.tennivalok = await firstValueFrom(this.http.get<any[]>('/api/caesar/tennivalok/' + this.ugyId)); await this.betolt(); }

  oradijElonezet(o: any) { const v = Number(o.osszeg); if (v > 0) return v; return Math.ceil((Number(o.ido_perc) || 0) / 60) * (Number(o.oradij) || 0); }
  async oradijAdd() { if (!this.ujOradij.leiras?.trim()) return this.hiba('Leírás kötelező.'); await this.post('/api/caesar/oradij/' + this.ugyId, this.ujOradij); this.oradijak = await firstValueFrom(this.http.get<any[]>('/api/caesar/oradijak/' + this.ugyId)); this.ujUres(); await this.betolt(); }
  async oradijToggle(o: any, mezo: string) { o[mezo] = o[mezo] ? 1 : 0; await firstValueFrom(this.http.put('/api/caesar/oradij/' + o.id, o)); await this.betolt(); }
  async oradijTorol(o: any) { await this.del('/api/caesar/oradij/' + o.id); this.oradijak = await firstValueFrom(this.http.get<any[]>('/api/caesar/oradijak/' + this.ugyId)); await this.betolt(); }
  get oradijOsszesen() { return this.oradijak.reduce((s, o) => s + Number(o.osszeg || 0), 0); }
  get oradijSzamlazatlan() { return this.oradijak.filter((o) => !o.szamlazva).reduce((s, o) => s + Number(o.osszeg || 0), 0); }
  szamlazNav() { this.router.navigateByUrl('/penzugy/szamlanew'); }

  tranzElonezet(k: any) { return Math.min(Math.round((Number(k.osszeg) || 0) * 0.0045), 20000); }
  async koltsegAdd() { if (!this.ujKoltseg.megnevezes?.trim()) return this.hiba('Megnevezés kötelező.'); await this.post('/api/caesar/koltseg/' + this.ugyId, this.ujKoltseg); this.koltsegek = await firstValueFrom(this.http.get<any[]>('/api/caesar/koltsegek/' + this.ugyId)); this.ujUres(); await this.betolt(); }
  async koltsegTorol(k: any) { await this.del('/api/caesar/koltseg/' + k.id); this.koltsegek = await firstValueFrom(this.http.get<any[]>('/api/caesar/koltsegek/' + this.ugyId)); await this.betolt(); }

  async letetAdd() { if (!this.ujLetet.jogcim?.trim()) return this.hiba('Jogcím kötelező.'); await this.post('/api/caesar/letet/' + this.ugyId, this.ujLetet); this.letetek = await firstValueFrom(this.http.get<any[]>('/api/caesar/letetek/' + this.ugyId)); this.ujUres(); await this.betolt(); }
  async letetLezar(l: any) { await firstValueFrom(this.http.put('/api/caesar/letet/' + l.id, { ...l, statusz: 'lezart', lezaras_datum: this.ma() })); this.letetek = await firstValueFrom(this.http.get<any[]>('/api/caesar/letetek/' + this.ugyId)); await this.betolt(); }
  async letetTorol(l: any) { await this.del('/api/caesar/letet/' + l.id); this.letetek = await firstValueFrom(this.http.get<any[]>('/api/caesar/letetek/' + this.ugyId)); await this.betolt(); }

  async pmtAdd() { await this.post('/api/caesar/pmt', this.ujPmt); this.pmtek = await firstValueFrom(this.http.get<any[]>('/api/caesar/pmt/ugy/' + this.ugyId)); this.ujUres(); }
  async pmtTorol(p: any) { await this.del('/api/caesar/pmt/' + p.id); this.pmtek = await firstValueFrom(this.http.get<any[]>('/api/caesar/pmt/ugy/' + this.ugyId)); }

  async levelAdd() { await this.post('/api/caesar/level/' + this.ugyId, this.ujLevel); this.levelek = await firstValueFrom(this.http.get<any[]>('/api/caesar/levelek/' + this.ugyId)); this.ujUres(); }
  async levelTorol(l: any) { await this.del('/api/caesar/level/' + l.id); this.levelek = await firstValueFrom(this.http.get<any[]>('/api/caesar/levelek/' + this.ugyId)); }

  // határnap szín a közelség szerint
  hatarnapSzin(datum: string): string {
    const d = new Date(datum + 'T00:00:00'); const ma = new Date(); ma.setHours(0, 0, 0, 0);
    const diff = Math.round((d.getTime() - ma.getTime()) / 86400000);
    if (diff < 0) return 'medium'; if (diff === 0) return 'danger'; if (diff === 1) return 'warning'; if (diff <= 4) return 'tertiary'; return 'success';
  }

  /* ---- hivatkozási számok ---- */
  async hivAdd() {
    if (!this.ujHiv.szam?.trim()) return this.hiba('A hivatkozási szám kötelező.');
    try {
      await firstValueFrom(this.http.post('/api/caesar/hivatkozas/' + this.ugyId, { ...this.ujHiv, intezmeny: this.intezmeny }));
      this.ujHiv = { hatosag_nev: '', szam: '', megjegyzes: '' };
      this.hivatkozasok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hivatkozasok/' + this.ugyId));
      this.ok('Hivatkozási szám rögzítve.');
    } catch { this.hiba('Nem sikerült rögzíteni.'); }
  }
  async hivTorol(h: any) {
    await firstValueFrom(this.http.delete('/api/caesar/hivatkozas/' + h.id));
    this.hivatkozasok = await firstValueFrom(this.http.get<any[]>('/api/caesar/hivatkozasok/' + this.ugyId));
  }

  vissza() { this.router.navigateByUrl('/caesar/ugyek'); }

  /* ---- Áttekintés ---- */
  async mentUgy() {
    if (!this.ugy?.leiras?.trim()) return this.hiba('Az ügy megnevezése kötelező.');
    try { await firstValueFrom(this.http.put('/api/caesar/ugy/' + this.ugyId, this.ugy)); await this.betolt(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async torolUgy() {
    const a = await this.alert.create({
      header: 'Ügy törlése', message: 'Az ügy és minden hozzá tartozó irat törlődik. Folytatja?',
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          await firstValueFrom(this.http.delete('/api/caesar/ugy/' + this.ugyId)); this.vissza();
        }
      }],
    });
    a.present();
  }

  /* ---- Szereplők ---- */
  ujSzereploModal() {
    this.ujSzereplo = { szemely_id: '', szerep: 'Ügyfél', szerepEgyeb: '', sajat_ugyfel: true, extraSorok: [] };
    this.szemelyKereso = '';
    this.szemelyValasztott = null;
    this.szereploModal.present();
  }
  // Kereshetős személyválasztó a szereplő-modalhoz (max 20 találat).
  get szemelyTalalatok() {
    const q = (this.szemelyKereso || '').trim().toLowerCase();
    if (!q) return [];
    return this.szemelyek
      .filter((s) => [s.nev, s.szuletesi_hely, s.szemelyi_szam].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)))
      .slice(0, 20);
  }
  valasztSzemely(s: any) {
    this.szemelyValasztott = s;
    this.ujSzereplo.szemely_id = s.id;
    this.szemelyKereso = '';
  }
  async szereploMent() {
    if (!this.ujSzereplo.szemely_id) return this.hiba('Válassz személyt.');
    const szerep = this.ujSzereplo.szerep === 'Egyéb' ? (String(this.ujSzereplo.szerepEgyeb || '').trim() || 'Egyéb') : this.ujSzereplo.szerep;
    try {
      await firstValueFrom(this.http.post('/api/caesar/ugy/' + this.ugyId + '/szereplo', {
        szemely_id: this.ujSzereplo.szemely_id, szerep,
        sajat_ugyfel: this.ujSzereplo.sajat_ugyfel, extra: this.ujSzereplo.extraSorok,
      }));
      await this.szereploModal.dismiss();
      await this.betolt();
      this.ok('Szereplő hozzáadva.');
    } catch { this.hiba('Nem sikerült hozzáadni.'); }
  }
  async szereploFrissit(s: any) {
    try { await firstValueFrom(this.http.put('/api/caesar/szereplo/' + s.id, { szerep: s.szerep, sajat_ugyfel: s.sajat_ugyfel, extra: s.extraSorok })); this.ok('Frissítve.'); }
    catch { this.hiba('Nem sikerült frissíteni.'); }
  }
  // Egyedi (loop-)mezők szerkesztése a szereplőn
  extraSorHozzad(target: any) { (target.extraSorok = target.extraSorok || []).push({ kulcs: '', ertek: '' }); }
  extraSorTorol(target: any, i: number) { target.extraSorok.splice(i, 1); }
  async szereploTorol(s: any) {
    await firstValueFrom(this.http.delete('/api/caesar/szereplo/' + s.id));
    await this.betolt();
  }
  szemelyhez(s: any) { this.router.navigateByUrl('/caesar/szemelyek'); }

  /* ---- Iratok ---- */
  async feltolt(ev: any) {
    const file: File = ev.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file, file.name);
    fd.append('intezmeny', this.intezmeny);
    fd.append('irany', this.feltoltIrany);
    fd.append('tipus', this.feltoltTipus);
    fd.append('nev', file.name);
    try {
      await firstValueFrom(this.http.post('/api/caesar/irat/' + this.ugyId, fd));
      this.iratok = await firstValueFrom(this.http.get<any[]>('/api/caesar/iratok/' + this.ugyId));
      await this.betolt();
      this.ok('Irat feltöltve.');
    } catch { this.hiba('Nem sikerült feltölteni az iratot.'); }
    ev.target.value = '';
  }
  // Blobként kérjük le (auth-interceptor ráteszi a tokent) – a sima window.open(url) 401-et adna.
  // PDF: előnézet új ablakban. DOCX (és egyéb): LETÖLTÉS a megfelelő névvel → a Word/LibreOffice
  // nyitja meg (a window.open egy docx-blobot az Electron-ablakban nem tud megjeleníteni).
  async letolt(i: any) {
    try {
      const blob = await firstValueFrom(this.http.get('/api/caesar/irat/' + i.id + '/download', { responseType: 'blob' }));
      const url = URL.createObjectURL(blob as Blob);
      const nev = i.nev || 'irat';
      if (/\.pdf$/i.test(nev)) {
        window.open(url, '_blank');
      } else {
        const a = document.createElement('a');
        a.href = url; a.download = nev;
        document.body.appendChild(a); a.click(); a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { this.hiba('Nem sikerült megnyitni az iratot.'); }
  }
  async torolIrat(i: any) {
    await firstValueFrom(this.http.delete('/api/caesar/irat/' + i.id));
    this.iratok = await firstValueFrom(this.http.get<any[]>('/api/caesar/iratok/' + this.ugyId));
    await this.betolt();
  }

  /* ---- iratkészítés sablonból / varázslóval ---- */
  iratkeszModalNyit() {
    this.iratkesz = { mod: 'sablon', id: '', pdf: true, alair: false, ertekek: {}, mezok: [] };
    this.iratkeszModal.present();
  }
  // csak az egyéni (kézzel kitöltendő) változókat kérjük be – a többit a backend automatikusan feloldja
  private egyeniMezok(valtozok: any[]) { return (valtozok || []).filter((v) => v.forras === 'egyeni'); }

  async forrasValt() {
    this.iratkesz.ertekek = {};
    if (!this.iratkesz.id) { this.iratkesz.mezok = []; return; }
    if (this.iratkesz.mod === 'sablon') {
      const s = this.sablonok.find((x) => x.id === this.iratkesz.id);
      this.iratkesz.mezok = this.egyeniMezok(s?.valtozok || []);
    } else {
      const v: any = await firstValueFrom(this.http.get('/api/caesar/varazslo/' + this.iratkesz.id));
      const unio: any = {};
      for (const s of v.sablonok || []) for (const mez of this.egyeniMezok(s.valtozok)) unio[mez.tag] = mez;
      this.iratkesz.mezok = Object.values(unio);
    }
  }

  async general() {
    if (!this.iratkesz.id) return this.hiba('Válassz sablont vagy varázslót.');
    this.keszites = true;
    const url = this.iratkesz.mod === 'sablon'
      ? '/api/caesar/sablon/' + this.iratkesz.id + '/general'
      : '/api/caesar/varazslo/' + this.iratkesz.id + '/general';
    const alair = !!this.iratkesz.alair && !!this.iratkesz.pdf && this.eszignoElerheto;
    try {
      const r: any = await firstValueFrom(this.http.post(url, { ugy_id: this.ugyId, ertekek: this.iratkesz.ertekek, pdf: this.iratkesz.pdf, alair }));
      await this.iratkeszModal.dismiss();
      this.segment = 'iratok';
      this.iratok = await firstValueFrom(this.http.get<any[]>('/api/caesar/iratok/' + this.ugyId));
      await this.betolt();
      // Aláírás-visszajelzés (egy sablon: r.alairva/r.alairas_hiba; varázsló: r.iratok[].…)
      const tetelek = r?.iratok || [r];
      const hiba = tetelek.find((x: any) => x && x.alairas_hiba)?.alairas_hiba;
      if (alair && hiba) this.hiba('Irat elkészült, de az aláírás nem sikerült: ' + hiba);
      else if (alair && tetelek.some((x: any) => x?.alairva)) this.ok('Irat(ok) elkészült és aláírva.');
      else this.ok('Irat(ok) elkészült.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült generálni.'); }
    finally { this.keszites = false; }
  }

  cimke(lista: any[], v: string) { return lista.find((x) => x.value === v)?.label || v || ''; }
  szin(a: string) { return { nyitott: 'primary', felfuggesztve: 'warning', lezarva: 'success' }[a] || 'medium'; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2500, color: 'danger' })).present(); }
}
